import script from "./DeviceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&setup=true&lang=js"

import "./DeviceDetails.vue?vue&type=style&index=0&id=e59aad7a&scoped=true&lang=css"
script.__scopeId = "data-v-e59aad7a"

export default script